const operations = new WeakMap();
export function getMediaOperationToken(element) { return { element, version: operations.get(element) || 0 }; }
export function isMediaOperationCurrent(token) { return Boolean(token?.element) && (operations.get(token.element) || 0) === token.version; }
export function cancelMediaOperation(element) { if (element) operations.set(element, (operations.get(element) || 0) + 1); }
function settleBoolean(value, timeoutMs) {
  return new Promise((resolve) => {
    let settled = false;
    const finish = (result) => { if (settled) return; settled = true; window.clearTimeout(timerId); resolve(Boolean(result)); };
    const timerId = window.setTimeout(() => finish(false), timeoutMs);
    Promise.resolve(value).then(finish, () => finish(false));
  });
}
export function pauseAndResetMedia(elements = [], resetTime = 0) {
  elements.filter(Boolean).forEach((element) => { cancelMediaOperation(element); try { element.pause(); if (Number.isFinite(resetTime)) element.currentTime = resetTime; } catch {} });
}
export async function startMediaElement(element, start, timeoutMs = 2400) {
  if (!element?.src || typeof start !== "function") return false;
  cancelMediaOperation(element);
  const token = getMediaOperationToken(element);
  let started = false;
  try { started = await settleBoolean(start(element), timeoutMs); } catch {}
  if (!isMediaOperationCurrent(token)) return false;
  if (!started || element.paused) { pauseAndResetMedia([element], null); return false; }
  return true;
}
export async function armMediaElement(element, start, timeoutMs = 1800) {
  const started = await startMediaElement(element, start, timeoutMs);
  if (!started) return false;
  pauseAndResetMedia([element], 0);
  return true;
}
export async function armMediaGroup(mainElement, optionalElements = [], start, timeoutMs = 1800) {
  const optional = optionalElements.filter((element) => element?.src);
  const mainArmed = await armMediaElement(mainElement, start, timeoutMs);
  if (!mainArmed) return { mainArmed: false, optionalResults: optional.map(() => false) };
  const optionalResults = [];
  for (const element of optional) optionalResults.push(await armMediaElement(element, start, timeoutMs));
  return { mainArmed: true, optionalResults };
}
export async function startMediaGroup(mainElement, optionalElements = [], start, timeoutMs = 2400) {
  const optional = optionalElements.filter((element) => element?.src);
  const [mainStarted, optionalResults] = await Promise.all([startMediaElement(mainElement, start, timeoutMs), Promise.all(optional.map((element) => startMediaElement(element, start, timeoutMs)))]);
  if (mainStarted && !mainElement.paused) return { mainStarted: true, optionalResults };
  pauseAndResetMedia(optional, 0);
  const fallbackStarted = await startMediaElement(mainElement, start, timeoutMs);
  return { mainStarted: Boolean(fallbackStarted && !mainElement.paused), optionalResults: optional.map(() => false) };
}
